import SlsClienteEnderecoClient from '@/api/Cadastros/Cliente/sls-cliente-endereco.client';
import Store from '@/store';

import { ErrorMessage } from '@/libs/Error';

export default class SLSClienteEnderecoService {
  constructor() {
    this.client = new SlsClienteEnderecoClient();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os Cliente');
    }
  }

  async findEnderecoCliente(queries) {
    try {
      const { data } = await this.client.getEnderecosCliente(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os Cliente');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Cliente');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Cliente');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Cliente');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.client.destroy(body);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Cliente');
    }
  }

  async getClienteEnderecoByClienteId(clienteid) {
    this.store.commit('SLSClienteEndereco/SET_LOADING', true);
    try {
      this.store.commit('SLSClienteEndereco/SET_CLIENTE_ID', clienteid);
      const data = await this.client.getClienteEnderecoByClienteId(clienteid);
      this.store.commit('SLSClienteEndereco/SET_ENDERECOS_CLIENTE', data);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Cliente');
    } finally {
      this.store.commit('SLSClienteEndereco/SET_LOADING', false);
    }
  }

  async getLocalEntregaCliente(clienteId, queries) {
    try {
      const data = await this.client.getLocalEntregaCliente(clienteId, queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Cliente');
    }
  }
}
